import ModalLayout from 'components/modal/modal-layout/ModalLayout';
import { Button, Modal } from 'react-bootstrap';
import styles from './MemberTable.module.scss';

const ConfirmDeleteModal = ({ onConfirmDelete, show, onClose, member }) => {
  return (
    <ModalLayout
      show={show}
      onHide={onClose}
      size='sm'
      showHeaderDivider
      Header='Delete Member'
      headerClass={styles['member_charts__header']}
      bodyClass={styles['member_charts__body']}
      dialogClassName={styles['member_charts__dialog']}
    >
      <Modal.Body>
        <p className='w-100 mb-4 text-center'>
          Do you want to remove{' '}
          {member ? <strong>{member.first_name}</strong> : 'this user'} from
          team?
        </p>
        <Modal.Footer>
          <Button variant='secondary' onClick={onClose}>
            Cancel
          </Button>
          <Button variant='danger' onClick={onConfirmDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal.Body>
    </ModalLayout>
  );
};

export default ConfirmDeleteModal;
